import { Dictionary } from '@models/common';
import React from 'react';
import { Prompt, Redirect } from 'react-router';
import { useLocation } from 'react-router-dom';
import { ConfirmModal } from './ConfirmModal';

type RoutingType = {
  when: boolean;
};

export const RoutingLeavingModal = ({ when }: RoutingType) => {
  const recentLocation = useLocation();
  const [openModal, setOpenModal] = React.useState(false);
  const [lastLocation, setLastLocation] = React.useState<Dictionary | null>(null);
  const [confirmNavigation, setConfirmNavigation] = React.useState(false);
  const handleShowModal = (location: any) => {
    setOpenModal(true);
    setLastLocation(location);
  };
  const handleBlockNavigation = (nextLocation: any) => {
    if (!confirmNavigation && when && nextLocation.pathname !== recentLocation.pathname) {
      handleShowModal(nextLocation);
      return false;
    }
    return true;
  };
  const handleDiscardChange = () => {
    setOpenModal(false);
    if (lastLocation) {
      setConfirmNavigation(true);
    }
  };
  if (confirmNavigation) {
    return <Redirect to={`${lastLocation?.pathname}`} />;
  }
  return (
    <React.Fragment>
      <Prompt when={when} message={handleBlockNavigation} />
      <ConfirmModal
        open={openModal}
        handleCancel={() => setOpenModal(false)}
        handleConfirm={handleDiscardChange}
        title='You have unsaved changes'
        subTitle='Do you want to discard these changes?'
        confirmText='Yes, discard changes'
      />
    </React.Fragment>
  );
};
